import React, { useState } from 'react';
import { canPurchasePattern } from '../../utils/lemonSqueezy';

export default function LemonSqueezyBuyButton({ pattern, className = '', isPreview = false }) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  if (isPreview) {
    return (
      <button
        type="button"
        disabled
        aria-disabled="true"
        title="Checkout is disabled in draft preview"
        className={`w-full rounded-lg bg-indigo-600 px-6 py-3 text-center font-medium text-white ${className}`}
      >
        Buy pattern · {Number(pattern.price || 0).toFixed(2)}€
      </button>
    );
  }

  if (!canPurchasePattern(pattern)) {
    return (
      <button
        type="button"
        disabled
        className={`w-full rounded-lg bg-stone-100 px-6 py-3 font-medium text-stone-500 ${className}`}
      >
        Available soon
      </button>
    );
  }

  const startCheckout = async () => {
    setError('');
    setIsLoading(true);

    try {
      const response = await fetch('/api/create-lemon-squeezy-checkout', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ patternId: pattern.id }),
      });
      const data = await response.json();

      if (!response.ok || !data.url) {
        throw new Error(data.error || 'Checkout is unavailable');
      }

      window.location.assign(data.url);
    } catch (checkoutError) {
      setError(checkoutError.message || 'Checkout is unavailable');
      setIsLoading(false);
    }
  };

  return (
    <div>
      <button
        type="button"
        onClick={startCheckout}
        disabled={isLoading}
        className={`w-full rounded-lg bg-indigo-600 px-6 py-3 text-center font-medium text-white transition-colors hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 disabled:cursor-wait disabled:opacity-60 ${className}`}
        aria-label={`Buy ${pattern.title} securely with Lemon Squeezy`}
      >
        {isLoading ? 'Opening secure checkout…' : `Buy pattern · ${Number(pattern.price).toFixed(2)}€`}
      </button>
      {error && <p className="mt-2 text-sm text-red-600" role="alert">{error}</p>}
    </div>
  );
}
